<template>
    <div id="top-area">
        <div class="container pt-5">
            <div class="d-flex flex-column flex-lg-row justify-content-between h-100 my-5">

                <div class="d-flex flex-column flex-lg-row" v-show="user">
                    <div class="text-center">
                        <img :src="profile_src" alt="" class="img-fluid profile">
                        <div class="w-100 text-center py-3 score">
                            <h5 v-text="user.total_score" v-if="user && user.total_score"></h5>
                            <h5 v-else>0</h5>
                        </div>
                    </div>
                    <div class="d-flex flex-column my-auto pt-4 pt-lg-0 pl-lg-5 align-items-center align-items-lg-start">
                        <h4 v-text="user.user_rank.name" v-if="user && user.user_rank"></h4>
                        <h3>
                            <span v-text="user.first_name" v-if="user && user.first_name"></span>
                            <span v-text="user.last_name" v-if="user && user.last_name" class="pl-2"></span>
                        </h3>
                    </div>
                </div>

                <div class="d-flex flex-column my-auto text-center">
                    <button @click="logout()">
                        <i class="fas fa-sign-out-alt"></i>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    const axios = require('axios');

    import Swal from 'sweetalert2';

    const  Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000
    });

    export default {
        name: "TopArea",
        data() {
            return {
                user: null,
                accessToken: null,
                profile_src: null,
                baseUrl: null,
                terminalUID: null,
                headers: null,
            }
        },
        created() {
            this.user = this.$store.getters.getUser;
            this.accessToken = this.$cookie.get('access-token');
            this.terminalUID = this.$cookie.get('terminal-uid');
            this.baseUrl = this.$cookie.get('base-url');
            this.headers = {
                'terminal-uid': this.terminalUID,
                'Access-Control-Allow-Headers': 'Authorization',
                'Authorization': this.accessToken,
                'Content-Type': 'application/json',
            };
            let self = this;

            if (this.user) {
                setTimeout(function () {
                    self.getProfileImage();
                }, 100);
            } else {
                self.getUserInfo();
            }
        },
        methods: {
            getUserInfo() {

                let infoUrl = this.baseUrl + 'api/auth/me';
                let self = this;
                const headers = this.headers;
                axios.defaults.headers.common['Authorization'] = this.accessToken;
                axios.defaults.headers.common['terminal-uid'] = this.terminalUID;

                axios.get(infoUrl, {headers})
                    .then(function (response) {
                        self.user = response.data.result.user;
                        self.$cookie.set('user_id', response.data.result.user.id, 1);
                        setTimeout(function () {
                            self.getProfileImage();
                        }, 100)
                    })
                    .catch(function (error) {
                        console.log('user info error', error);

                        if (error.response) {
                            console.error('Status:', error.response.status);
                            if (error.response.status === 400 ||
                                error.response.status === 401 ||
                                error.response.status === 402 ||
                                error.response.status === 403 ||
                                error.response.status === 404) {
                                self.$store.commit('setUser', null);
                                self.$cookie.delete('access-token');
                                self.$cookie.delete('user-token');
                                self.$cookie.delete('terminal_id');
                                self.$cookie.delete('user_type_id');
                                self.$cookie.delete('terminal-uid');
                                self.$cookie.delete('user_id');
                                // self.$forceUpdate();
                                // location.reload();
                            }
                        } else {
                            console.error('Error Message:', error.message);
                        }
                    });

            },
            getProfileImage() {
                this.accessToken = this.$cookie.get('access-token');
                this.terminalUID = this.$cookie.get('terminal-uid');
                let imageUrl = this.user.profile_pic_url;
                let self = this;

                const params = {
                    width: '250',
                    height: '250',
                    bypass_user: '1'
                };

                self.profile_src = require('../../assets/imgs/profile/no-pic.png');

                const headers = {
                    'terminal-uid': this.terminalUID,
                    'Access-Control-Allow-Headers': 'Authorization',
                    'Authorization': this.accessToken,
                };
                axios.defaults.headers.common['Authorization'] = this.accessToken;

                axios.get(
                    imageUrl,
                    {
                        params,
                        responseType: 'blob',
                        headers
                    })
                    .then(function (response) {
                        let reader = new FileReader();
                        reader.readAsDataURL(response.data);
                        reader.onload = () => {
                            self.profile_src = reader.result;
                        }
                    })
                    .catch(function (error) {
                        console.log('error', error);
                    });
            },
            logout() {
                const $ = window.$;
                const headers = {
                    'terminal-uid': this.terminalUID,
                    'Access-Control-Allow-Headers': 'Authorization',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': this.accessToken,
                };
                let self = this;
                axios.defaults.headers.common['Authorization'] = this.accessToken;

                axios.post(
                    this.baseUrl + 'auth/logout',
                    {headers})
                    .then(function () {
                        // console.log('response', response);

                        self.$store.commit('setUser', null);

                        self.$cookie.delete('access-token');
                        self.$cookie.delete('user-token');
                        self.$cookie.delete('terminal_id');
                        self.$cookie.delete('user_type_id');
                        self.$cookie.delete('terminal-uid');
                        self.$cookie.delete('user_id');

                        if (self.$cookie.get('access-token') && self.$cookie.get('access-token') !== '') {
                            $('#toggleLoginModal').removeClass('d-block');
                            $('#myProfile').removeClass('d-none');
                            $('#toggleLoginModal').addClass('d-none');
                            $('#myProfile').addClass('d-block')
                        } else {
                            $('#toggleLoginModal').removeClass('d-none');
                            $('#myProfile').removeClass('d-block');
                            $('#toggleLoginModal').addClass('d-block');
                            $('#myProfile').addClass('d-none');
                        }

                        setTimeout(function () {
                            // self.$router.push('/');
                            $('#toggleLoginModal').addClass('d-block');
                            $('#myProfile').addClass('d-none');
                            self.$forceUpdate();
                            location.reload();

                            Toast.fire({
                                type: 'error',
                                title: 'Succes!'
                            });

                        }, 100);
                    })
                    .catch(function (error) {
                        console.log('error', error);

                        self.$store.commit('setUser', null);

                        self.$cookie.delete('access-token');
                        self.$cookie.delete('user-token');
                        self.$cookie.delete('terminal_id');
                        self.$cookie.delete('user_type_id');
                        self.$cookie.delete('terminal-uid');
                        self.$cookie.delete('user_id');

                        if (self.$cookie.get('access-token') && self.$cookie.get('access-token') !== '') {
                            $('#toggleLoginModal').removeClass('d-block');
                            $('#myProfile').removeClass('d-none');
                            $('#toggleLoginModal').addClass('d-none');
                            $('#myProfile').addClass('d-block')
                        } else {
                            $('#toggleLoginModal').removeClass('d-none');
                            $('#myProfile').removeClass('d-block');
                            $('#toggleLoginModal').addClass('d-block');
                            $('#myProfile').addClass('d-none');
                        }

                        setTimeout(function () {
                            // self.$router.push('/');
                            $('#toggleLoginModal').addClass('d-block');
                            $('#myProfile').addClass('d-none');
                            self.$forceUpdate();
                            location.reload();
                        }, 100);

                        Toast.fire({
                            type: 'error',
                            title: 'A aparut o eroare.'
                        });
                    });

            }
        }
    }
</script>

<style scoped>

</style>